export {
	EDITABLE_FIELD_ACTION_BUTTON_BASE_CLASS,
	EDITABLE_FIELD_IMPROVE_SPLIT_SEGMENT_CLASS,
	EditableFieldConfirmActions,
	type EditableFieldConfirmActionsProps,
	EditableFieldImproveSplitButton,
	type EditableFieldImproveSplitButtonProps,
	EditableFieldPencilButton,
	type EditableFieldPencilButtonProps,
	EditableFieldRowStepper,
	type EditableFieldRowStepperProps,
	FIELD_CONFIRM_BUTTON_BASE_CLASS,
} from "./actions";
export {
	CompactToggleIncludeActions,
	type CompactToggleIncludeActionsProps,
} from "./compact-toggle-include-actions";
export {
	EDITABLE_FIELD_COLUMN_CLASS,
	EDITABLE_FIELD_COLUMNS_SHELL_CLASS,
	EDITABLE_FIELD_CONTROL_SURFACE_CLASS,
	EDITABLE_FIELD_FOOTER_BAR_CLASS,
	EDITABLE_FIELD_HEADER_BAR_CLASS,
	EDITABLE_FIELD_HEADER_BG_CLASS,
	EDITABLE_FIELD_HEADER_BG_GRADIENT_CLASS,
	EDITABLE_FIELD_HEADER_BG_PLAIN_CLASS,
	EDITABLE_FIELD_HEADER_GRADIENT_OVERLAY_CLASS,
	EDITABLE_FIELD_HEADER_SEPARATOR_CLASS,
	EDITABLE_FIELD_HEADER_TITLE_CLASS,
	EDITABLE_FIELD_HEADER_VARIANT_DEFAULT,
	EDITABLE_FIELD_INPUT_BG_CLASS,
	EDITABLE_FIELD_PANEL_CLASS,
	EDITABLE_FIELD_SCROLL_MARGIN_CLASS,
	EDITABLE_FIELD_SECTION_BG_CLASS,
	EDITABLE_FIELD_SECTION_CLASS,
	EDITABLE_FIELD_STACK_CLASS,
	type EditableFieldHeaderVariant,
} from "./chrome";
export {
	type EditableFieldContextValue,
	EditableFieldProvider,
	useEditableField,
} from "./context";
export {
	EditableFieldBody,
	type EditableFieldBodyProps,
	EditableFieldColumn,
	EditableFieldColumns,
	type EditableFieldColumnsProps,
	EditableFieldFooter,
	type EditableFieldFooterProps,
	EditableFieldHeader,
	type EditableFieldHeaderProps,
	EditableFieldRoot,
	type EditableFieldRootProps,
	EditableFieldSeparator,
	EditableFieldTitle,
} from "./editable-field";
export { focusEditableControlAtStart } from "./focus";
export {
	EDITABLE_FIELD_SCROLL_TOP_PADDING_PX,
	getEditableFieldScrollParent,
	scrollEditableFieldIntoView,
} from "./scroll";
export { useFocusEditableControlWhen } from "./use-focus-editable-control-when";
export { useScrollEditableFieldIntoViewWhen } from "./use-scroll-editable-field-into-view-when";

import {
	EditableFieldConfirmActions,
	EditableFieldImproveSplitButton,
	EditableFieldPencilButton,
	EditableFieldRowStepper,
} from "./actions";
import {
	EditableFieldBody,
	EditableFieldColumn,
	EditableFieldColumns,
	EditableFieldFooter,
	EditableFieldHeader,
	EditableFieldRoot,
	EditableFieldSeparator,
	EditableFieldTitle,
} from "./editable-field";

/**
 * Compound EditableField — opaque chrome aligned with module structure tiles.
 *
 * Body stays section-coloured while editing; style Input / Textarea / TipTap
 * with core control surfaces. Pencil → edit scrolls the field into view
 * (with scroll-margin padding) and pairs with {@link useFocusEditableControlWhen}.
 */
export const EditableField = Object.assign(EditableFieldRoot, {
	Header: EditableFieldHeader,
	Body: EditableFieldBody,
	Footer: EditableFieldFooter,
	Columns: EditableFieldColumns,
	Column: EditableFieldColumn,
	Title: EditableFieldTitle,
	Separator: EditableFieldSeparator,
	ConfirmActions: EditableFieldConfirmActions,
	PencilButton: EditableFieldPencilButton,
	ImproveSplitButton: EditableFieldImproveSplitButton,
	RowStepper: EditableFieldRowStepper,
});
